import { useAtomValueRawSync, useSetAtom } from 'jotai';
import type { ReactElement } from 'react';
import React from 'react';

import { DropdownMenuRadioGroup, DropdownMenuRadioItem } from '@/components/shadcn/dropdown-menu';
import { setThemePreferenceAtom, themePreferenceAtom } from '@/state/ui/themeAtoms';
import { ThemePreference } from '@/types/panels';

interface ThemeOption {
    value: ThemePreference;
    label: string;
}

const THEME_OPTIONS: readonly ThemeOption[] = [
    { value: ThemePreference.Light, label: 'Light' },
    { value: ThemePreference.Dark, label: 'Dark' },
    { value: ThemePreference.System, label: 'Matching system theme' },
];

export const ThemeRadioGroup = (): ReactElement => {
    const themePreference = useAtomValueRawSync(themePreferenceAtom);
    const setThemePreference = useSetAtom(setThemePreferenceAtom);
    return (
        <DropdownMenuRadioGroup
            value={themePreference}
            onValueChange={(value): void => {
                // The group gives back a bare string.
                const pickedOption = THEME_OPTIONS.find((option) => option.value === value);
                if (pickedOption) {
                    setThemePreference(pickedOption.value);
                }
            }}
        >
            {THEME_OPTIONS.map(({ value, label }) => (
                <DropdownMenuRadioItem
                    key={value}
                    value={value}
                >
                    {label}
                </DropdownMenuRadioItem>
            ))}
        </DropdownMenuRadioGroup>
    );
};
